module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"complete-task":"Complete task","task-completed":"Task completed","show-more":"Show more","options":"Options","edit":"Edit","delete":"Delete","to":"to"},"pt-BR":{"complete-task":"Finalizar tarefa","task-completed":"Tarefa finalizada","show-more":"Mostrar informações","options":"Opções","edit":"Editar","delete":"Deletar","to":"até"}}')
  delete Component.options._Ctor
}
